module.exports = __webpack_public_path__ + "img/error.f4a2801d.png";